document.addEventListener("DOMContentLoaded", function () {
  // Find all price list containers on the page
  const priceListContainers = document.querySelectorAll(".custom-price-list");

  priceListContainers.forEach(function (priceListContainer) {
    const blockId = priceListContainer.dataset.blockId;
    const sectionId = priceListContainer.dataset.sectionId;

    if (!blockId || !sectionId) return;

    const quantityInput = document.querySelector("#Quantity-" + sectionId);
    if (!quantityInput) return;

    let variantChangeUnsubscriber = undefined;

    function updateActiveTier(quantity) {
      // console.log('🎯 updateActiveTier called with quantity:', quantity);
      const tiers = priceListContainer.querySelectorAll(".price-tier");
      let activeTier = null;

      // Get cart data for enhanced quantity calculation
      const priceListsElement = document.getElementById(
        "variant-price-lists-" + sectionId,
      );
      let totalQuantity = quantity; // Default to just the input quantity

      if (priceListsElement) {
        try {
          const priceLists = JSON.parse(priceListsElement.textContent);
          if (priceLists.cartData) {
            // Determine if we're using product-level or variant-level pricing
            const currentVariantId = getCurrentVariantId();
            const variantPriceList = priceLists.variants[currentVariantId];
            const isVariantLevelPricing =
              variantPriceList && variantPriceList.length > 0;

            if (isVariantLevelPricing) {
              // Variant-level: only count this specific variant
              const variantCartQty =
                priceLists.cartData.variantQuantities[currentVariantId] || 0;
              totalQuantity = variantCartQty + quantity;
              // console.log('🔍 Variant-level pricing - Cart qty:', variantCartQty, 'Page qty:', quantity, 'Total:', totalQuantity);
            } else {
              // Product-level: count all variants of this product
              totalQuantity = priceLists.cartData.totalProductQty + quantity;
              // console.log('🔍 Product-level pricing - Cart qty:', priceLists.cartData.totalProductQty, 'Page qty:', quantity, 'Total:', totalQuantity);
            }
          }
        } catch (e) {
          console.error("❌ Error parsing price lists data:", e);
        }
      }

      // Find the highest tier that the total quantity qualifies for
      tiers.forEach((tier) => {
        const tierElement = tier;
        const fromAmount = parseInt(tierElement.dataset.fromAmount);
        if (totalQuantity >= fromAmount) {
          activeTier = tierElement;
        }
      });

      // Update active states
      tiers.forEach((tier) => {
        tier.classList.remove("price-tier--active");
      });

      if (activeTier) {
        activeTier.classList.add("price-tier--active");
        // console.log('✅ Active tier updated to:', activeTier.dataset.fromAmount);
      }
      //  else {
      //   console.log('⚠️ No active tier found for total quantity:', totalQuantity);
      // }
    }

    // Function to refresh cart data from server
    function refreshCartData() {
      console.log("🔄 refreshCartData called for section:", sectionId);
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          // console.log('📦 Fetched cart data:', cart);
          // Update the price lists data with fresh cart information
          const priceListsElement = document.getElementById(
            "variant-price-lists-" + sectionId,
          );
          if (priceListsElement) {
            try {
              const priceLists = JSON.parse(priceListsElement.textContent);

              // Calculate new cart quantities
              let newTotalProductQty = 0;
              const newVariantQuantities = {};

              cart.items.forEach((item) => {
                // Check if this item belongs to the current product
                const productId = priceListContainer.dataset.productId;
                if (productId && item.product_id.toString() === productId) {
                  newTotalProductQty += item.quantity;
                  newVariantQuantities[item.variant_id] =
                    (newVariantQuantities[item.variant_id] || 0) +
                    item.quantity;
                }
              });

              // console.log('🛒 Updated cart quantities - Product:', newTotalProductQty, 'Variants:', newVariantQuantities);

              // Update the cart data
              priceLists.cartData.totalProductQty = newTotalProductQty;
              priceLists.cartData.variantQuantities = newVariantQuantities;
              priceLists.cartData.currentVariantQty =
                newVariantQuantities[getCurrentVariantId()] || 0;

              // Update the JSON element with fresh data
              priceListsElement.textContent = JSON.stringify(priceLists);

              // Update the active tier with fresh data
              const quantity = parseInt(quantityInput.value) || 1;
              // console.log('🎯 Updating active tier with quantity:', quantity);
              updateActiveTier(quantity);
            } catch (e) {
              console.error("❌ Error updating cart data:", e);
            }
          } else {
            console.warn(
              "⚠️ Price lists element not found for sectionId:",
              sectionId,
            );
          }
        })
        .catch((error) => {
          console.error("❌ Error fetching cart data:", error);
        });
    }

    function getCurrentVariantId() {
      // Try multiple selectors to find the current variant
      const variantSelect = document.querySelector('select[name="id"]');
      const variantRadios = document.querySelectorAll(
        'input[name="id"][type="radio"]:checked',
      );
      const variantHidden = document.querySelector(
        'input[name="id"][type="hidden"]',
      );

      if (variantSelect) {
        return variantSelect.value;
      } else if (variantRadios.length > 0) {
        return variantRadios[0].value;
      } else if (variantHidden) {
        return variantHidden.value;
      }

      // Fallback - try to get from the price list container data
      return priceListContainer.dataset.currentVariantId || "";
    }

    function updateVariantPrice(variant) {
      if (!variant || !variant.price) return;

      // Find the first price tier (Ab 1)
      const firstTier = priceListContainer.querySelector(
        '.price-tier[data-from-amount="1"]',
      );
      if (!firstTier) return;

      const priceInEuros = (variant.price / 100).toFixed(2);
      const taxMultiplier = 1.19;
      const grossPrice = (priceInEuros * taxMultiplier).toFixed(2);

      // Get the main price container
      const mainPriceElement = firstTier.querySelector(".main-price");
      if (!mainPriceElement) return;

      // Check if variant has compare_at_price and it's higher than the current price
      const hasComparePrice =
        variant.compare_at_price && variant.compare_at_price > variant.price;

      if (hasComparePrice) {
        const comparePriceInEuros = (variant.compare_at_price / 100).toFixed(2);

        // Update or create price amount container with sale and old prices
        mainPriceElement.innerHTML = `
              <div class="price-amount-container">
                <span class="price-amount price-amount-sale">${priceInEuros.replace(".", ",")} €*</span>
                <span class="price-amount price-amount--old">${comparePriceInEuros.replace(".", ",")} €*</span>
              </div>
            `;
      } else {
        // Update to simple price display
        mainPriceElement.innerHTML = `
              <span class="price-amount">${priceInEuros.replace(".", ",")} €*</span>
            `;
      }

      // Update the gross price using constant tax multiplier
      const grossPriceElement = firstTier.querySelector(".gross-price");
      if (grossPriceElement) {
        grossPriceElement.textContent =
          grossPrice.replace(".", ",") + " € Brutto";
      }

      // Update the unit price in the first tier keeping Shopify's original format
      const basePriceElement = firstTier.querySelector(".base-price");
      if (basePriceElement && variant.unit_price) {
        // Get the original Shopify formatted string (e.g., "€5,18/l" or "€0,03 pro Stück")
        const priceListsElement = document.getElementById(
          "variant-price-lists-" + sectionId,
        );
        if (priceListsElement) {
          try {
            const priceLists = JSON.parse(priceListsElement.textContent);
            const originalFormat =
              priceLists.variantUnitMeasurements[variant.id];

            if (originalFormat) {
              // Calculate the new unit price with comma formatting
              const newUnitPrice = (variant.unit_price / 100)
                .toFixed(2)
                .replace(".", ",");
              // Replace the price part in the original format string
              const updatedFormat = originalFormat.replace(
                /€[\d,\.]+/,
                "€" + newUnitPrice,
              );
              basePriceElement.textContent = `${updatedFormat}`;
            }
          } catch (e) {
            console.error("Error parsing unit measurements:", e);
          }
        }
      }
    }

    function updatePriceListForVariant(variant) {
      if (!variant || !variant.id) return;

      // Update the current variant ID in the container data attribute
      priceListContainer.dataset.currentVariantId = variant.id;

      // Get the price lists data
      const priceListsElement = document.getElementById(
        "variant-price-lists-" + sectionId,
      );
      if (!priceListsElement) return;

      const priceLists = JSON.parse(priceListsElement.textContent);

      // Get the container for the tiers (excluding the first "Ab 1" tier)
      const tiersContainer = priceListContainer.querySelector(
        ".price-list-container",
      );
      if (!tiersContainer) return;

      // Find the disclaimer button to insert tiers before it
      const disclaimerButton =
        tiersContainer.querySelector(".price-disclaimer");

      // Remove existing tiers (except the first "Ab 1" tier)
      const existingTiers = tiersContainer.querySelectorAll(
        '.price-tier:not([data-from-amount="1"])',
      );
      existingTiers.forEach((tier) => tier.remove());

      // Get the price list for this variant
      let priceListToUse = priceLists.variants[variant.id];

      if (!priceListToUse || priceListToUse.length === 0) {
        priceListToUse = priceLists.product;
      }

      // If no price list is available, just update active tier and return
      if (!priceListToUse || priceListToUse.length === 0) {
        const currentQuantity = parseInt(quantityInput.value) || 1;
        updateActiveTier(currentQuantity);
        return;
      }

      // Sort tiers by from_amount
      const sortedTiers = priceListToUse.sort(
        (a, b) => a.from_amount - b.from_amount,
      );

      // Add new tiers
      const variantPrice = variant.price / 100;

      sortedTiers.forEach((tier) => {
        const tierElement = document.createElement("div");
        tierElement.className = "price-tier";
        tierElement.dataset.fromAmount = tier.from_amount;

        const discountedPrice = (
          variantPrice - tier.fixed_discount_amount
        ).toFixed(2);
        const grossPrice = (discountedPrice * 1.19).toFixed(2);

        // Calculate unit price for discounted tier keeping Shopify's original format
        let unitPriceText = "";
        if (variant.unit_price) {
          // Replicate the Liquid calculation: discounted_price * 100 * variant.unit_price / variant.price
          const discountedPriceInCents = discountedPrice * 100;
          const calculatedUnitPrice =
            (discountedPriceInCents * variant.unit_price) / variant.price;
          const calculatedUnitPriceFormatted = (calculatedUnitPrice / 100)
            .toFixed(2)
            .replace(".", ",");

          // Get the original Shopify formatted string and replace price part
          const originalFormat = priceLists.variantUnitMeasurements[variant.id];
          if (originalFormat) {
            const updatedFormat = originalFormat.replace(
              /€[\d,\.]+/,
              "€" + calculatedUnitPriceFormatted,
            );
            unitPriceText = `${updatedFormat}`;
          }
        }

        // Check if this tier has a compared_at_fixed_discount_amount (similar to Liquid logic)
        const hasComparedAtDiscount = tier.copmared_at_fixed_discount_amount;
        let mainPriceHTML = "";
        if (hasComparedAtDiscount) {
          const comparedAtDiscountedPrice =
            (+tier.copmared_at_fixed_discount_amount).toFixed(2);

          if (comparedAtDiscountedPrice > discountedPrice) {
            mainPriceHTML = `
                  <div class="price-amount-container">
                    <span class="price-amount price-amount-sale">${discountedPrice.replace(".", ",")} €*</span>
                    <span class="price-amount price-amount--old">${comparedAtDiscountedPrice.replace(".", ",")} €*</span>
                  </div>
                `;
          } else {
            mainPriceHTML = `<span class="price-amount">${discountedPrice.replace(".", ",")} €*</span>`;
          }
        } else {
          mainPriceHTML = `<span class="price-amount">${discountedPrice.replace(".", ",")} €*</span>`;
        }

        tierElement.innerHTML = `
              <div class="price-tier__content">
                <div class="price-tier__quantity">
                  <span class="quantity-text">Ab ${tier.from_amount}</span>
                  <div class="base-price">
                    ${unitPriceText}
                  </div>
                </div>
                <div class="price-tier__pricing">
                  <div class="price-tier__pricing-container">
                    <div class="main-price">
                      ${mainPriceHTML}
                    </div>
                    <div class="gross-price">${grossPrice.replace(".", ",")} € Brutto</div>
                  </div>
                </div>
              </div>
            `;

        // Insert before the disclaimer button if it exists, otherwise append to end
        if (disclaimerButton) {
          tiersContainer.insertBefore(tierElement, disclaimerButton);
        } else {
          tiersContainer.appendChild(tierElement);
        }
      });

      // Update active tier based on current quantity
      const currentQuantity = parseInt(quantityInput.value) || 1;
      updateActiveTier(currentQuantity);

      // Also update the first tier (Ab 1) with the correct tax multiplier
      updateVariantPrice(variant);
    }

    // Listen for quantity changes
    quantityInput.addEventListener("change", function () {
      const quantity = parseInt(this.value) || 1;
      updateActiveTier(quantity);
    });

    // Listen for input events (for real-time updates)
    quantityInput.addEventListener("input", function () {
      const quantity = parseInt(this.value) || 1;
      updateActiveTier(quantity);
    });

    // Listen for custom quantity update events
    document.addEventListener("quantity:updated", function (event) {
      if (event.detail && event.detail.sectionId === sectionId) {
        const quantity = parseInt(quantityInput.value) || 1;
        updateActiveTier(quantity);
      }
    });

    // Listen for cart updates
    document.addEventListener("cart:updated", function (event) {
      // console.log('🛒 Event: cart:updated fired', event);
      if (event.detail && event.detail.cart) {
        refreshCartData();
      }
    });

    // Listen for other cart-related events
    document.addEventListener("cart:change", function () {
      // console.log('🛒 Event: cart:change fired');
      refreshCartData();
    });

    document.addEventListener("cart:refresh", function () {
      // console.log('🛒 Event: cart:refresh fired');
      refreshCartData();
    });

    // Listen for cart drawer/overlay interactions
    document.addEventListener("click", function (event) {
      // Check if cart quantity buttons were clicked
      if (
        event.target.matches("[data-cart-quantity-button]") ||
        event.target.closest("[data-cart-quantity-button]") ||
        event.target.matches(".cart-quantity-button") ||
        event.target.closest(".cart-quantity-button") ||
        event.target.matches("[data-cart-quantity]") ||
        event.target.closest("[data-cart-quantity]") ||
        event.target.matches(".cart-quantity") ||
        event.target.closest(".cart-quantity") ||
        event.target.matches("[data-quantity-button]") ||
        event.target.closest("[data-quantity-button]") ||
        event.target.matches(".quantity-button") ||
        event.target.closest(".quantity-button")
      ) {
        // console.log('🖱️ Click: Cart quantity button detected', event.target);
        setTimeout(() => {
          refreshCartData();
        }, 300);
      }
    });

    // Listen for cart item removal
    document.addEventListener("click", function (event) {
      if (
        event.target.matches("[data-cart-remove]") ||
        event.target.closest("[data-cart-remove]") ||
        event.target.matches(".cart-remove") ||
        event.target.closest(".cart-remove") ||
        event.target.matches("[data-remove-item]") ||
        event.target.closest("[data-remove-item]") ||
        event.target.matches(".remove-item") ||
        event.target.closest(".remove-item")
      ) {
        // console.log('🗑️ Click: Cart item remove button detected', event.target);
        setTimeout(() => {
          refreshCartData();
        }, 300);
      }
    });

    // Listen for add to cart events
    document.addEventListener("click", function (event) {
      if (
        event.target.matches("[data-add-to-cart]") ||
        event.target.closest("[data-add-to-cart]") ||
        event.target.matches(".product-form__submit") ||
        event.target.closest(".product-form__submit") ||
        event.target.matches("[data-add-to-cart-button]") ||
        event.target.closest("[data-add-to-cart-button]") ||
        event.target.matches(".add-to-cart-button") ||
        event.target.closest(".add-to-cart-button")
      ) {
        // console.log('➕ Click: Add to cart button detected', event.target);
        setTimeout(() => {
          refreshCartData();
        }, 500);
      }
    });

    // Listen for cart drawer open/close events
    document.addEventListener("cart:drawer:opened", function () {
      // console.log('📂 Event: cart:drawer:opened fired');
      refreshCartData();
    });

    document.addEventListener("cart:drawer:closed", function () {
      // console.log('📂 Event: cart:drawer:closed fired');
      refreshCartData();
    });

    // Listen for any AJAX cart updates
    document.addEventListener("ajax:success", function (event) {
      if (
        event.detail &&
        event.detail.url &&
        event.detail.url.includes("/cart")
      ) {
        // console.log('📡 Event: ajax:success (cart related) fired');
        setTimeout(() => {
          refreshCartData();
        }, 200);
      }
    });

    // Listen for fetch cart updates
    document.addEventListener("fetch:success", function (event) {
      if (
        event.detail &&
        event.detail.url &&
        event.detail.url.includes("/cart")
      ) {
        // console.log('📡 Event: fetch:success (cart related) fired');
        setTimeout(() => {
          refreshCartData();
        }, 200);
      }
    });

    // Listen for form submissions that might be cart-related
    document.addEventListener("submit", function (event) {
      if (event.target.action && event.target.action.includes("/cart")) {
        // console.log('📝 Event: form submit (cart related) fired');
        setTimeout(() => {
          refreshCartData();
        }, 500);
      }
    });

    // Listen for input changes in cart drawer
    document.addEventListener("input", function (event) {
      if (
        event.target.closest("[data-cart-drawer]") ||
        event.target.closest(".cart-drawer") ||
        event.target.closest("[data-cart]") ||
        event.target.closest(".cart")
      ) {
        console.log("⌨️ Event: input in cart area detected", event.target);
        setTimeout(() => {
          refreshCartData();
        }, 300);
      }
    });

    // Listen for change events in cart drawer
    document.addEventListener("change", function (event) {
      if (
        event.target.closest("[data-cart-drawer]") ||
        event.target.closest(".cart-drawer") ||
        event.target.closest("[data-cart]") ||
        event.target.closest(".cart")
      ) {
        // console.log('🔄 Event: change in cart area detected', event.target);
        setTimeout(() => {
          refreshCartData();
        }, 300);
      }
    });

    // Listen for custom cart events
    document.addEventListener("cart:quantity:changed", function () {
      // console.log('🛒 Event: cart:quantity:changed fired');
      refreshCartData();
    });

    document.addEventListener("cart:item:added", function () {
      // console.log('🛒 Event: cart:item:added fired');
      refreshCartData();
    });

    document.addEventListener("cart:item:removed", function () {
      // console.log('🛒 Event: cart:item:removed fired');
      refreshCartData();
    });

    // Listen for any custom events that might be cart-related
    document.addEventListener("cart:updated:success", function () {
      // console.log('🛒 Event: cart:updated:success fired');
      refreshCartData();
    });

    document.addEventListener("cart:updated:error", function () {
      // console.log('🛒 Event: cart:updated:error fired');
      refreshCartData();
    });

    // Listen for variant changes using pubsub
    variantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      (event) => {
        if (event.data && event.data.variant) {
          console.log("Variant changed:", event.data.variant);
          // Small delay to ensure Shopify's updates complete
          setTimeout(() => {
            updateVariantPrice(event.data.variant);
            updatePriceListForVariant(event.data.variant);
          }, 50);
        }
      },
    );

    // Set up MutationObserver to watch for cart changes
    const cartObserver = new MutationObserver(function (mutations) {
      let shouldRefresh = false;
      mutations.forEach(function (mutation) {
        if (mutation.type === "childList" || mutation.type === "attributes") {
          // Check if the mutation is in a cart-related element
          const target = mutation.target;
          if (
            target.closest("[data-cart-drawer]") ||
            target.closest(".cart-drawer") ||
            target.closest("[data-cart]") ||
            target.closest(".cart") ||
            target.closest("[data-cart-items]") ||
            target.closest(".cart-items")
          ) {
            shouldRefresh = true;
          }
        }
      });

      if (shouldRefresh) {
        // console.log('👁️ MutationObserver detected cart change');
        setTimeout(() => {
          refreshCartData();
        }, 200);
      }
    });

    // Start observing cart-related elements
    const cartElements = document.querySelectorAll(
      "[data-cart-drawer], .cart-drawer, [data-cart], .cart, [data-cart-items], .cart-items",
    );
    cartElements.forEach((element) => {
      cartObserver.observe(element, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["data-quantity", "data-cart-quantity"],
      });
    });

    // Initial update
    const initialQuantity = parseInt(quantityInput.value) || 1;
    updateActiveTier(initialQuantity);

    // Cleanup function
    function cleanup() {
      if (variantChangeUnsubscriber) {
        variantChangeUnsubscriber();
      }
      if (cartObserver) {
        cartObserver.disconnect();
      }
    }

    // Cleanup when the element is removed
    priceListContainer.addEventListener("remove", cleanup);
    window.addEventListener("beforeunload", cleanup);
  });
});
